import React, { type RefObject } from "react";

// Returns a getter of one stable ref per key, so every TransitionGroup child
// keeps its own nodeRef while it exits.
export function createNodeRefs<T extends HTMLElement = HTMLElement>(): (
  key: string,
) => RefObject<T | null> {
  const refs: Record<string, RefObject<T | null>> = {};
  return key => {
    if (!refs[key]) {
      refs[key] = React.createRef<T>();
    }
    return refs[key];
  };
}
